export const constants = {
    mapping: {
        'assistant-history': '/spaces/{space}/assistants/{assistant}/chat/history',
        'chat-history': '/spaces/{space}/assistants/{assistant}/chat/history/{chatID}',
        'chat-completion': '/spaces/{space}/assistants/{assistant}/chat/completion',
        'speech-to-text': '/spaces/{space}/assistants/{assistant}/speech-to-text',
        'metadata': '/spaces/{space}/metadata',
    }
}